import { Circle, CheckCircle2 } from "lucide-react";
import { Button } from "../../../../components/ui/button";

interface DocumentStatusProps {
  state?: "approved" | "pending" | "rejected";
  isNotRequired?: boolean;
  onConfirm?: () => void;
}

export const DocumentStatus = ({
  state,
  isNotRequired,
  onConfirm,
}: DocumentStatusProps) => {
  if (isNotRequired) {
    return (
      <div className="flex items-center gap-2">
        <Circle className="w-4 h-4 text-gray-300" />
        <span className="text-sm text-gray-400">Not Required</span>
      </div>
    );
  }

  if (state === "pending") {
    return (
      <div className="">
        <Button variant="outline" onClick={onConfirm}>
          Confirm
        </Button>
      </div>
    );
  }

  if (state === "approved") {
    return (
      <div className="flex items-center gap-2">
        <CheckCircle2 className="w-4 h-4 text-green-500" />
        <span className="text-sm text-gray-600">Matched</span>
      </div>
    );
  }

  return <div className="flex items-center gap-2"></div>;
};
